import { PhoneOff, NotebookPen, CalendarX2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const moments = [
    {
        icon: PhoneOff,
        step: "01",
        title: "Tentou agendar fora do horário",
        text: "Ligou, mandou mensagem, ninguém respondeu. Em dois minutos ele já está falando com o concorrente.",
    },
    {
        icon: NotebookPen,
        step: "02",
        title: "Anotado no papel — e esquecido",
        text: "A agenda ficou na planilha ou no caderno. O lembrete nunca saiu. O cliente não foi avisado.",
    },
    {
        icon: CalendarX2,
        step: "03",
        title: "Faltou. Horário perdido.",
        text: "O paciente não apareceu. Aquele horário não volta — e a receita dele também não.",
    },
];

export const Problem = () => {
    return (
        <section id="problema" className="relative py-24 md:py-32 lg:py-40">
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                <Reveal>
                    <p className="text-sm md:text-base font-semibold uppercase tracking-widest text-[#94B4FF]">
                        O problema
                    </p>
                    <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#F5F5F5] max-w-3xl">
                        O que acontece todo dia em consultórios e escritórios
                    </h2>
                </Reveal>

                <div className="mt-14 grid md:grid-cols-3 gap-6 md:gap-8">
                    {moments.map((m, i) => (
                        <Reveal key={m.step} delay={i * 0.12}>
                            <div
                                data-testid={`problem-card-${i}`}
                                className="group relative h-full rounded-2xl border border-[#1E1E28] bg-[#121218] p-8 overflow-hidden transition-colors hover:border-[#3B6FFF]/40"
                            >
                                <div className="absolute -top-10 -right-6 text-[7rem] font-display font-extrabold leading-none dg-text-stroke select-none">
                                    {m.step}
                                </div>
                                <div className="relative">
                                    <div className="inline-flex items-center justify-center rounded-xl border border-[#1E1E28] bg-[#0A0A0F] p-3 text-[#FF6B5B] shadow-[0_0_20px_rgba(255,107,91,0.15)]">
                                        <m.icon className="w-6 h-6" />
                                    </div>
                                    <h3 className="mt-6 font-display text-xl font-semibold text-[#F5F5F5]">
                                        {m.title}
                                    </h3>
                                    <p className="mt-3 text-[#F5F5F5]/60 leading-relaxed">
                                        {m.text}
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2}>
                    <p className="mt-12 text-lg md:text-xl text-[#F5F5F5]/80 max-w-2xl font-display">
                        Não é falta de esforço. É falta de alguém{" "}
                        <span className="text-[#3B6FFF]">disponível 24 horas</span> pra
                        não deixar nenhum cliente escapar.
                    </p>
                </Reveal>
            </div>
        </section>
    );
};

export default Problem;
